import CreateAppointment from "./CreateAppointment";

export default CreateAppointment;
